<template>
	<div>
		<h1 class="vrnu-headline">Anbieter</h1>
    <vrnu-text-box v-bind:variant="'info'">
      Über die Anbieterverwaltung können Gutscheinanbieter angelegt, bearbeitet und gelöscht werden.
      Um einen Gutschein anzulegen, muss zuerst ein Anbieter angelegt werden, dem der Gutschein zugeordnet werden kann.
    </vrnu-text-box>
    <vrnu-list-wizard 	v-bind:listData="listData"
							v-on:delete="deleteProvider"
							v-on:saveSuccess="saveSuccess"
							v-on:saveError="saveError"></vrnu-list-wizard>
							
		<!-- Info modal -->
		<b-modal ref="infoModal" centered hide-footer title="Info">
			<p>{{ infoModalMessage }}</p>
			<slot name="modal-ok">
				<b-button class="vrnu-button" v-on:click="$refs.infoModal.hide()">Ok</b-button>
			</slot>
	    </b-modal>	    
	</div>
</template>

<script>
import ListWizard from '@/components/99_wizards/ListWizard';

export default {
	data: function() {
		return {
			providers: [],
			infoModalMessage: null,
			listData: {
				name: "Anbieter",
				confirmAttribute: 'name',
				formModule: 'vrnu-providers-form',
				viewModule: 'vrnu-providers-view',
				target: 'providers',
				pagination: true,
				filter: true,
				fields: [
					{
						key: 'name',
						label: 'Name',
						sortable: true						
					},
					{
						key: 'category',
						label: 'Kategorie',
						sortable: true,
						formatter: function(value) {
							var name = '';
							
							switch(value) {
								case 'sports':
									name = 'Sport'
									break;
								case 'food':
									name = 'Essen & Getränke'
									break;
								case 'shops':
									name = 'Shopping'
									break;
								case 'season':
									name = 'Saisonales'
									break;
								case 'leisure':
									name = 'Freizeit'
									break;
							}
							
							return name;								
						},
					},
					{
						key: 'active',
						label: 'Aktiv',
						sortabel: true,
						formatter: function(value) { return (value == true) ? ("Ja") : ("Nein")},
					},
				],
				actions: [
					{
						type: 'view',
						text: 'Anbieter öffnen',
						icon: 'icon-eye',
					},
					{
						type: 'update',
						text: 'Anbieter bearbeiten',
						icon: 'icon-pencil',
					},
					{
						type: 'delete',
						text: 'Anbieter löschen',
						icon: 'icon-trash',
						// target: '/user/deleteUserManually/{id}',
					},
				],
			},
		};
	},
	methods: {
		getProviders: function() {
			// Get providers from server
			this.$http.get('providers').then(providers => {
				this.providers = providers.body;
			}, response => {
				this.providers = "Es ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator!";
			});
		},
		deleteProvider: function(id) {
			// Get providers from server
			this.$http.delete('providers/' + id).then(response => {
				var providerName = response.body.name;
				this.openInfoModal("Der Anbieter \"" + providerName + "\" wurde erfolgreich gelöscht.");
			}, response => {
			  console.log(response);
			  if(response.status === 409) {
          this.openInfoModal(response.body.msg);
        } else {
          this.openInfoModal("Beim Löschen des Anbieters ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator.");
        }
			});
		},
		saveSuccess: function(result) {
			this.openInfoModal("Der Anbieter \"" + result.body.name + "\" wurde erfolgreich gespeichert.");
		},
		saveError: function(response) {
			this.openInfoModal("Beim Speichern des Anbieters ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator.");
		},
		openInfoModal: function(message) {
			this.infoModalMessage = message;
			this.$refs.infoModal.show();
		},
	},
	created: function() {
		// Get providers from server and display them
		this.getProviders();
	},
	components: {
		'vrnu-list-wizard': ListWizard,
	}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/03_provider/Providers.vue